import React from 'react'
import Pagination from '../../../components/Pagination'
import moment from 'moment-timezone';

const badgeClasses = {
  withdraw: 'bg-amber-100 text-amber-600 dark:bg-amber-500/10 dark:text-amber-200',
  deposit: 'bg-customAccent/20 text-customAccent dark:bg-blue-500/10 dark:text-blue-300',

  approved: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300',
  rejected: 'bg-rose-100 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300',
}

const TransactionHistoryTable = ({
  transactions = [],
  page = 1,
  pageSize = transactions.length || 10,
  totalItems = transactions.length,
  onPageChange,
  onPageSizeChange,
  isMobile
}) => {
  console.log('Rendering TransactionHistoryTable with transactions:', transactions);
  const buildBadgeClasses = (key) => {
    return (
      badgeClasses[key] ??
      'bg-slate-100 text-slate-600 dark:bg-customSurfaceMuted/40 dark:text-customHeading'
    )
  }

  //slate-50/80  text-slate-500

  console.log("nn", transactions.map(a => a));

  return (
    <div className="overflow-hidden rounded-md border border-customSurface/10 bg-white shadow-xl shadow-slate-900/5 dark:border-customSurface dark:bg-customSurface">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-100 dark:divide-customSurfaceMuted">
          <thead className="bg-background text-xs uppercase tracking-wide text-customLightMilkWhite dark:bg-custom_dark_primary2/40 dark:text-customMuted">
            <tr>
              <th className="px-5 py-3 text-left min-w-[50px]">Transaction</th>
              <th className="px-5 py-3 text-left">User ID</th>
              <th className={`px-2 py-3 text-left ${isMobile ? 'min-w-[150px]' : 'min-w-full'}`}>Account Info</th>
              <th className="px-5 py-3 text-left">Amount</th>
              <th className="px-5 py-3 text-left">Type</th>
              <th className="px-5 py-3 text-left">Status</th>
              {/* <th className="px-2 py-3 text-right min-w-[100px]">Remark</th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-sm dark:divide-customSurfaceMuted/50">
            {transactions.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="px-5 py-10 text-center text-sm text-slate-500 dark:text-customMuted"
                >
                  No transactions for the selected filters.
                </td>
              </tr>
            ) : (
              transactions.map((item) => (
                <tr key={item.id} className="transition hover:bg-slate-50 dark:hover:bg-customSurfaceMuted/50">
                  <td className="px-2 py-3">
                    <div className="font-semibold text-customPrimaryText dark:text-customHeading">
                      {item.transactionNo}
                    </div>
                    {item.remark && (
                      <p className="text-xs text-customSecondaryText dark:text-customMuted">
                        {item.remark}
                      </p>
                    )}
                  </td>
                  <td className="px-2 py-3 dark:text-customLightMilkWhite">
                    {item.userName ?? 'N/A'}
                  </td>
                  <td className="px-2 py-3">
                    <div className={`${isMobile ? 'flex flex-col' : 'flex gap-2 items-center'}`}>
                      <p className='text-xs text-customSecondaryText dark:text-customMuted font-semibold'>
                        {item.type === "withdraw" ? 'Transfer To' : 'Transfer From'} - 
                      </p>
                      <div className='flex'>
                        <img
                          src={require(`../../../assets/banks/${item?.bankType}.png`)}
                          alt={item.bankType}
                          className="mb-1 h-10 w-10 rounded-sm object-contain"
                          onError={(e) => { e.target.onerror = null; e.target.src = require('../../../assets/banks/dollar.png'); }}
                        />
                        <div className="flex flex-col text-sm font-medium text-customPrimaryText dark:text-customHeading">
                          {item.accountName ?? 'N/A'}
                          <p className="text-xs text-customSecondaryText dark:text-customMuted">
                            {item.accountNo ?? item.accountNumber ?? 'Unknown'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-2 py-3">
                    <div className="font-semibold text-customPrimaryText dark:text-customHeading">
                      {item.currency ?? 'USD'} {item.amount?.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-2 py-3">
                    <span
                      className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold capitalize ${buildBadgeClasses(
                        item.type,
                      )}`}
                    >
                      {item.type}
                    </span> 
                      <p className="text-xs text-customSecondaryText dark:text-customMuted">
                       {item.createdDate}
                      </p>
                  </td>
                  <td className="px-2 py-3">
                    <span
                      className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold capitalize ${buildBadgeClasses(
                        item.status,
                      )}`}
                    >
                      {item.status}
                    </span>
                      <p className="text-xs text-customSecondaryText dark:text-customMuted">
                       {item.updatedDate}
                      </p>
                  </td>
                  {/* <td className="px-2 py-3 text-right">
                    <div className={`${isMobile ? 'text-xs' : 'text-sm'} font-medium text-customPrimaryText dark:text-customHeading`}>
                      <span> {item.remark}</span>                   
                    </div>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {typeof onPageChange === 'function' ? (
        <Pagination
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pageSizeOptions={[5, 10, 20, 50]}
          className="rounded-b-md bg-customLightMilkWhite/60 dark:bg-customSurfaceMuted/40"
        />
      ) : null}
    </div>
  )
}

export default TransactionHistoryTable
